import React from 'react';

const GeneralChart = (props: {
  title?: string;
  subTitle?: string;
  id?: string;
  children?: React.ReactNode;
  padding?: string;
  margin?: string;
  tip?: string;
  subTip?: string;
  tipBgColor?: string;
  border?: string;
  onClick?: () => void;
}) => {
  const {
    title,
    subTitle,
    id,
    children,
    padding = 'p-8',
    margin = 'my-8',
    tip,
    subTip,
    tipBgColor = 'bg-web-green-100',
    border = 'border border-web-tertiary',
    onClick,
  } = props;
  if (Array.isArray(children) && children.filter(Boolean).length === 0)
    return null;
  return (
    <div
      id={id}
      className={`${padding} ${margin} rounded-lg ${border}`}
      onClick={onClick}
    >
      {title && <h3 className="text-xl font-semibold mb-4">{title}</h3>}
      {subTitle && (
        <h4 className="text-sm text-web-grey-550 mb-4">{subTitle}</h4>
      )}
      {subTip && <p className="text-sm text-web-grey-550 mb-4">{subTip}</p>}
      {children}
      {tip && (
        <p
          className={`p-4 mt-4 text-sm rounded-lg ${tipBgColor}`}
        >{`💡 ${tip}`}</p>
      )}
    </div>
  );
};

export default GeneralChart;
